import { PostCroquisSketchQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postCroquisSketch/postCroquisSketchQuery.type';
import { postCroquisSketchFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postCroquisSketch/postCroquisSketchQueryFunction';

export const postCroquisSketchQueryOptions = () => {
  return {
    mutationKey: ['postCroquisSketch'],
    mutationFn: (params: PostCroquisSketchQueryParamsType) =>
      postCroquisSketchFunction(params),
  };
};
